import { isNil } from "lodash";

export const cx = (...args: (string | boolean | undefined | null)[]) => {
  return args?.filter((arg) => !isNil(arg)).join(" ");
};
